var _defs, _rect, _path, _image, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.014,
    height: 100.014,
    viewBox: "0 0 1055 1055",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #282c31;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #000;\n        stroke-width: 1px;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        fill-rule: evenodd;\n      }\n\n      .cls-3 {\n        fill: #ef4c38;\n      }\n\n      .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-4 {\n        stroke: #282c31;\n        stroke-width: 4.68px;\n      }\n\n      .cls-5 {\n        stroke: #fff;\n        stroke-width: 8px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_4",
    "data-name": "Ret\\xE2ngulo 4",
    className: "cls-1",
    x: -92,
    y: -87,
    width: 1239,
    height: 1279
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_4-2",
    "data-name": "Ret\\xE2ngulo 4",
    className: "cls-2",
    d: "M85,86H969V969H85V86Zm0,0H969V969H85V86Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "Ret\\xE2ngulo_4-3",
    "data-name": "Ret\\xE2ngulo 4",
    x: 85,
    y: 86,
    width: 884,
    height: 883,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAYAAAAcaxDBAAAA9ElEQVR4nO3dMRECQRREwc8W6RpACSLw7wBSgjNAnYcOKHjtYJ6Bubwf9+fM7IlwXGfmVkpmr7Pqj4z5Bsf69wJaQbGCYgXFCooVFCsoVlCsoFhBsYJiBcUKihUUKyhWUKygWEGxgmIFxQqKFRQrKFZQrKBYQbGCYgXFCooVFCsoVlCsoFhBsYJiBcUKihUUKyhWUKygWEGxgmIFxQqKFRQrKFZQrKBYQbGCYgXFCooVFCsoVlCsoFhBsYJiBcUKihUUKyhWUKygWEGxgmIFxQqKFRQrKFZQrKBYQbGCYgXFCooVFCsotnr7ovb5+PUqKjJzfADhQQgRLfJf8wAAAABJRU5ErkJggg=="
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_3",
    "data-name": "Forma 3",
    className: "cls-2",
    d: "M248.643,298.1L15.23,754.8l1026.61-10.332-236.516-447.4ZM1217.41,52.184"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_1",
    "data-name": "Forma 1",
    className: "cls-3",
    d: "M14.094,756.783h21.08L275.482,301.315l-12.647-3.163Zm152.828-8.435,171.8-451.25,14.755,3.163L188,748.348h-21.08Zm147.558,0,20.026,1.054,98.02-449.141-14.756-1.055ZM491.627,299.53l-37.2,453.491,148.808-2.66L575.331,298.2Zm146.427-3.487,94.858,452.3,20.026,3.163L649.647,294.989Zm82.21,6.326L874.146,750.457h24.242L735.02,300.261ZM1025.92,750.457l16.86-5.272L804.291,299.133,786.734,298.1ZM11.986,761L1047,757.837M105.083,570.88L13.164,751.7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_4",
    "data-name": "Forma 4",
    className: "cls-4",
    d: "M64,749L290,299l31,1L122,750h96L368,302l37,1L275,750l81,2,88-451h33L426,750H641L592,301h30l80,447,77,1L667,300l29,1L840,748l83-2L750,300l27-1L997,746"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Forma_2",
    "data-name": "Forma 2",
    className: "cls-5",
    d: "M8,755.68l1039-6.649L807.844,295.54l-559.359,1.33ZM63,752"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHatch);
export default __webpack_public_path__ + "static/media/hatch.cad7811cc1e8d28b285d5b2bf19df7f6.svg";
export { ForwardRef as ReactComponent };